import React from 'react'
import CountUp from 'react-countup'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import Fade from 'react-reveal/Fade'
import styled from 'styled-components'

import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import Layout from 'components/Layout'
import TwoColumns from 'components/utils/TwoColumns'
import VisibilitySensorOnce from 'components/utils/VisibilitySensorOnce'
import PageHero from 'components/UI/PageHero'
import LogoKemkominfo from 'images/logo-kominfo.inline.svg'
import { Header3, Header4, Header6, HeaderUnderline } from 'components/UI/Header'

const MarketCounter = props => {
    return (
    <div className="text-center mb-8 md:text-left">
        <VisibilitySensorOnce partialVisibility offset={{ bottom: 100 }}>
            {({ isVisible }) => (
            <div className="text-5xl h-12">
                {isVisible ? <CountUp end={ props.end } separator="." duration={1} useEasing={ true } /> : null}
            </div>
            )}
        </VisibilitySensorOnce>
        <p className="text-gray-600">{ props.label }</p>
    </div>
    )
}

const Landscape = () => {

    return (
        <Layout pageTitle="The Landscapes" pageGroup="landscape" floatingHeader>
            <PageHero title="The Landscapes" bgStyle="dashed" />
            <section className="bg-black text-white">
                <ResponsiveContainer className="py-20 lg:py-32">
                    <Fade>
                        <Header3 className="text-center max-w-xl mx-auto mb-12">Indonesia Startup Potential in Numbers</Header3>
                        <div className="grid gap-12 grid-cols-1 mb-12 md:grid-cols-2 md:gap-8 lg:grid-cols-4">
                            <div className="text-center md:text-left">
                                <div className="relative mb-6">
                                    <StaticImage src="../images/bg-user.jpg" width={500} aspectRatio={5/3} placeholder="blurred" className="relative z-0 max-w-full" />
                                    <div className="absolute inset-0 bg-black z-10 bg-opacity-50">
                                        <VisibilitySensorOnce partialVisibility offset={{ bottom: 100 }}>
                                            {({ isVisible }) => (
                                            <div className="h-full flex flex-col justify-center items-center text-4xl font-bold md:text-7xl">
                                                {isVisible ? <CountUp end={27} separator="." duration={1} useEasing={ true } /> : null}
                                                <span className="text-xl">million</span>
                                            </div>
                                            )}
                                        </VisibilitySensorOnce>
                                    </div>
                                </div>
                                <Header6>Internet user in Indonesia increased by 27 million (16%)  users between 2020 and 2021.</Header6>
                            </div>
                            <div className="text-center md:text-left">
                                <div className="relative mb-6">
                                    <StaticImage src="../images/bg-penetration.jpg" width={500} aspectRatio={5/3} placeholder="blurred" className="relative z-0 max-w-full" />
                                    <div className="absolute inset-0 bg-black z-10 bg-opacity-50">
                                        <VisibilitySensorOnce partialVisibility offset={{ bottom: 100 }}>
                                            {({ isVisible }) => (
                                            <div className="h-full flex flex-col justify-center items-center text-4xl font-bold md:text-7xl">
                                                {isVisible ? <CountUp end={73.7} separator="." duration={1} useEasing={ true } decimals={1} /> : null}
                                                <span className="text-xl">percent</span>
                                            </div>
                                            )}
                                        </VisibilitySensorOnce>
                                    </div>
                                </div>
                                <Header6>Internet penetration in Indonesia stood at 73.7% in January 2021.</Header6>
                            </div>
                            <div className="text-center md:text-left">
                                <div className="relative mb-6">
                                    <StaticImage src="../images/bg-leader.jpg" width={500} aspectRatio={5/3} placeholder="blurred" className="relative z-0 max-w-full" />
                                    <div className="absolute inset-0 bg-black z-10 bg-opacity-50">
                                        <VisibilitySensorOnce partialVisibility offset={{ bottom: 100 }}>
                                            {({ isVisible }) => (
                                            <div className="h-full flex flex-col justify-center items-center text-4xl font-bold md:text-7xl">
                                                {isVisible ? <div className="inline-flex">$<CountUp end={26.3} separator="." duration={1} useEasing={ true } decimals={1} /></div> : null}
                                                <span className="text-xl">billion</span>
                                            </div>
                                            )}
                                        </VisibilitySensorOnce>
                                    </div>
                                </div>
                                <Header6>Indonesia is the leader of emerging startup ecosystems with $26.3 billion worth of value.</Header6>
                            </div>
                            <div className="text-center md:text-left">
                                <div className="relative mb-6">
                                    <StaticImage src="../images/bg-fund.jpg" width={500} aspectRatio={5/3} placeholder="blurred" className="relative z-0 max-w-full" />
                                    <div className="absolute inset-0 bg-black z-10 bg-opacity-50">
                                        <VisibilitySensorOnce partialVisibility offset={{ bottom: 100 }}>
                                            {({ isVisible }) => (
                                            <div className="h-full flex flex-col justify-center items-center text-4xl font-bold md:text-7xl">
                                                {isVisible ? <div className="inline-flex">$<CountUp end={845.9} separator="." duration={1} useEasing={ true } decimals={1} /></div> : null}
                                                <span className="text-xl">million</span>
                                            </div>
                                            )}
                                        </VisibilitySensorOnce>
                                    </div>
                                </div>
                                <Header6>In 2017-2018, Indonesia has the highest early-stage funding with $845.9 million worth of funds.</Header6>
                            </div>
                        </div>
                        <div className="text-center">
                            <Link to="/agenda" className="underline text-primary font-bold">See all Agenda</Link>
                        </div>
                    </Fade>
                </ResponsiveContainer>
            </section>
            <section className="bg-primary-lighter">
                <ResponsiveContainer className="py-20 lg:py-32">
                    <HeaderUnderline className="mb-12" title={<>Why Jejala?</>} titleClass="text-primary" underlineClass="w-10/12 h-auto"  />
                    <Fade>
                        <TwoColumns>
                            <p>Based on the 2020 Global Startup Ecosystem Report by Startup Genome, Jakarta, Indonesia placed 2nd as the top emerging startup ecosystem, with a total ecosystem value of US$26.3B. Indonesia’s internet economy is thriving, with an average growth rate of 49% a year since 2015. With this pace, by 2025, Indonesia’s internet economy value is expected to pass US$130 (SEA Internet Economy Report, 2019).</p>
                            <p>By September 2021, Indonesia has 1 decacorn company (Gojek), and several unicorn companies (some of the well-known ones including Tokopedia, Traveloka, Bukalapak, OVO, JD.id, and Xendit). This shows the potential of Indonesian tech startups to scale in the coming future.</p>
                            <p>Through Jejala, the Indonesian Ministry of Communications and Informatics tries to facilitate the meets of global venture capitalists and Indonesian early-stage tech startups.</p>
                        </TwoColumns>
                    </Fade>
                </ResponsiveContainer>
            </section>
            <section>
                <ResponsiveContainer className="py-20 lg:py-32">
                    <HeaderUnderline className="mb-12" title={<>Market<br />Opportunity</>} titleClass="text-primary" underlineClass="w-10/12 h-auto"  />
                    <Fade>
                        <MarketOppDiv>
                            <Header4>Ease of Foreign Investment Rules for Startups in Indonesia</Header4>
                            <p>The government has unveiled a draft of presidential regulation which proposes to lift some of the rules concerning foreign investment in tech-based start-ups. It aims to limit the restrictions on foreign investment (from special economic zones) to the minimum requirement of more than Rp 10 billion (US$710,111). It is also intended to ease the process for start-ups to hire foreign workers without being required to have a government-approved plan to use foreign employees, which is included in the current article of the jobs law. The main goal is to decrease the barriers and give more capacity to startups to attract investment and human talent.</p>
                        </MarketOppDiv>
                    </Fade>
                </ResponsiveContainer>
            </section>
        </Layout>
    )
}

const MarketOppDiv = styled.div`
    @media (min-width: 768px) {
        column-count: 2;
        gap: 2rem;
    }
`

export default Landscape
